import styled from "@emotion/styled";

import { theme } from "../../../../../Controls/Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const ErrorText = styled.span(props => ({
    color: props.theme.candy.semanticColors.danger.color,
}));

export const ZeroReportingDescription = styled.div(props => ({
    ...theme(props).typography.primary.css(),
}));
